import { render, staticRenderFns } from "./DefaultUserLocaleResetButton.vue?vue&type=template&id=449ffe7c&"
import script from "./DefaultUserLocaleResetButton.vue?vue&type=script&lang=js&"
export * from "./DefaultUserLocaleResetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports